import { ASSETS } from '../assets'
import { formatWithLineBreaks } from '../utils/formatText'

export const PopupModal = ({
  text,
  isVisible,
  yesCtaLabel = 'Yes',
  noCtaLabel = 'No',
  countdown,
  onYes,
  onNo,
  onClose,
}: {
  text: string
  isVisible: boolean
  yesCtaLabel?: string
  noCtaLabel?: string
  countdown?: number
  onYes?: () => void
  onNo?: () => void
  onClose?: () => void
}) => {
  if (!isVisible) return null

  return (
    <div className="bg-opacity-75 fixed inset-0 z-60 flex items-center justify-center bg-black/70">
      <div className="border-gray relative flex w-192 flex-col gap-18 border-2 bg-black px-12 py-25 text-center shadow-xl">
        {/* Close (top-right) */}
        <div
          className="group border-blue hover:border-blue-tint-3 active:border-blue-tint-3 absolute -top-6 -right-6 flex flex-shrink-0 items-center justify-center rounded-full border-3 bg-transparent hover:cursor-pointer"
          style={{ width: 65, height: 65 }}
          onClick={onClose}
          aria-label="Close"
        >
          <div
            className="bg-blue group-hover:bg-blue-tint-3 group-active:bg-blue-tint-3 flex flex-shrink-0 items-center justify-center rounded-full"
            style={{ width: 50, height: 50 }}
          >
            <img src={ASSETS.iconCross} width={17} height={17} className="rotate-45" />
          </div>
        </div>

        {/* Question */}
        <p className="mt-10 flex flex-1 flex-col text-[36px] leading-[50px] font-normal tracking-[0]">
          {formatWithLineBreaks(text)}
        </p>

        {/* Options */}
        <div className="flex items-center justify-between">
          <button
            onClick={onYes}
            className={[
              'relative inline-flex items-center transition-colors',
              'min-h-18 w-80',
              'px-2 py-1',
              'rounded-full border-2',
              'border-green text-green cursor-pointer bg-transparent',
              'hover:bg-green/10 active:bg-green/10',
            ].join(' ')}
          >
            <img src={ASSETS.iconCorrect} alt="yes" className="mr-4 inline-block h-14 w-14" />
            <span className="text-[30px] leading-[30px] font-normal">{yesCtaLabel}</span>
          </button>

          <button
            onClick={onNo}
            className={[
              'relative inline-flex items-center transition-colors',
              'min-h-18 w-80',
              'px-2 py-1',
              'rounded-full border-2',
              'border-red text-red cursor-pointer bg-transparent',
              'hover:bg-red/10 active:bg-red/10',
            ].join(' ')}
          >
            <img
              src={ASSETS.iconIncorrectDanger}
              alt="no"
              className="mr-4 inline-block h-14 w-14"
            />
            <span className="text-[30px] leading-[30px] font-normal">
              {noCtaLabel} {countdown && countdown > 0 && `(${countdown})`}
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
